import localization from "assets/localization/localization";
import axios from "services/interceptor/Interceptor";
import { SHOW_HIDE_TOAST } from "services/redux/sales/appNotifications/type";
import { store } from "services/redux/store";
export const callTypes = {
  get: "GET",
  post: "POST",
  upload: "UPLOAD",
  put: "PUT",
  delete: "DELETE",
  patch: "PATCH",
};
export function showToast(error) {
  let errorMsg = "";
  // Accept either a raw axios response ({ data }) or an axios error object
  // ({ response: { data } }). fusion-backend-go returns real HTTP 4xx/5xx for
  // errors, so the body arrives as error.response.data on GET/PUT/DELETE/PATCH.
  const body = error?.data ?? error?.response?.data;
  // Handle existing v2 API response format
  if (body?.response) {
    errorMsg = body.message || body.response?.message;
  }
  // Handle new v2 API response format with status: 1
  else if (Number(body?.status) === 1) {
    errorMsg = body?.message || "Something went wrong";
    if (body?.errors && typeof body.errors === "object" && !Array.isArray(body.errors)) {
      const fieldMsgs = Object.values(body.errors).filter(Boolean);
      if (fieldMsgs.length) {
        errorMsg = fieldMsgs.join(". ");
      }
    }
  }
  // Handle other error formats
  else if (body?.message) {
    errorMsg = body.message;
  }
  else {
    // errorMsg = localization.oppsWrong;
  }
  if(errorMsg != ""){
    store.dispatch({
      type: SHOW_HIDE_TOAST,
      payload: { isToast: true, toastMessage: errorMsg },
    });
  }
}

// CTE check-in conflict: Calculator shows confirm dialog — skip duplicate error toast.
function isCteCheckinConflict(error, requestData, url) {
  if (requestData?.module_type !== "cte_ticket") {
    return false;
  }
  if (!url || !url.includes("site-to-eng-distance-calculator")) {
    return false;
  }
  const status = error?.response?.status ?? error?.status;
  if (status !== 409) {
    return false;
  }
  const body = error?.response?.data ?? error?.data;
  return Boolean(body?.data?.active_checkin_id);
}

// Recon service-invoice list uses status 1 + message SUCCESS for a successful
// payload. Other v2 APIs use status 1 for errors, so this exception stays URL-scoped.
const isReconServiceInvoiceListSuccess = (url, body) =>
  typeof url === "string" &&
  url.includes("/v1/fusion/service-invoice/list") &&
  Number(body?.status) === 1 &&
  String(body?.message || "").toUpperCase() === "SUCCESS";

export default async function callWebService(requestType, data, url, config) {
  switch (requestType) {
    case callTypes.get: {
      const getApiResult = await axios.get(url, config).catch((error) => {
        showToast(error);
      });
      // Handle both existing and new v2 API response formats
      if (getApiResult?.data?.response?.status === false && getApiResult?.data?.status_code != 401) {
        showToast(getApiResult);
      }
      // Handle new v2 API response format with status: 1 for errors
      else if (getApiResult?.data?.status === 1) {
        showToast(getApiResult);
      }
      return getApiResult;
    }
    case callTypes.post: {
      try {
        const postApiResult = await axios.post(url, data, config);
        // For HTTP 200, handle both existing and new v2 API response formats
        if (postApiResult?.data?.response?.status === false && postApiResult?.data?.status_code != 401) {
          showToast(postApiResult);
        }
        // Handle new v2 API response format with status: 1 for errors.
        // Recon service-invoice list returns status 1 on success.
        else if (
          postApiResult?.data?.status === 1 &&
          !isReconServiceInvoiceListSuccess(url, postApiResult.data)
        ) {
          showToast(postApiResult);
        }
        return postApiResult;
      } catch (error) {
        // fusion-backend-go returns real HTTP 4xx/5xx (e.g. 422 validation).
        // Show the message and return the response so callers can exit cleanly.
        if (!isCteCheckinConflict(error, data, url)) {
          showToast(error);
        }
        return error?.response;
      }
    }
    case callTypes.put: {
      const putApiResult = await axios.put(url, data).catch((error) => {
        showToast(error);
      });
      // Handle both existing and new v2 API response formats
      if (putApiResult?.data?.response?.status === false && putApiResult?.data?.status_code != 401) {
        showToast(putApiResult);
      }
      // Handle new v2 API response format with status: 1 for errors
      else if (putApiResult?.data?.status === 1) {
        showToast(putApiResult);
      }
      return putApiResult;
    }
    case callTypes.delete: {
      const deleteApiResult = await axios
        .delete(url, { data })
        .catch((error) => {
          showToast(error);
        });
      // Handle both existing and new v2 API response formats
      if (deleteApiResult?.data?.response?.status === false && deleteApiResult?.data?.status_code != 401) {
        showToast(deleteApiResult);
      }
      // Handle new v2 API response format with status: 1 for errors
      else if (deleteApiResult?.data?.status === 1) {
        showToast(deleteApiResult);
      }
      return deleteApiResult;
    }
    case callTypes.patch: {
      const patchApiResult = await axios.patch(url, data, config).catch((error) => {
        showToast(error);
      });
      // Handle both existing and new v2 API response formats
      if (patchApiResult?.data?.response?.status === false && patchApiResult?.data?.status_code != 401) {
        showToast(patchApiResult);
      }
      // Handle new v2 API response format with status: 1 for errors
      else if (patchApiResult?.data?.status === 1) {
        showToast(patchApiResult);
      }
      return patchApiResult;
    }
  }
}
export function waitForCustomEvent(
  eventName,
  target = window,
  enableFallback = false
) {
  return new Promise((resolve) => {
    const eventListener = (event) => {
      if (event instanceof CustomEvent && event.type === eventName) {
        resolve(event);
        target.removeEventListener(eventName, eventListener);
      }
    };
    target.addEventListener(eventName, eventListener);
    if (enableFallback) {
      setTimeout(() => {
        resolve(null);
        target.removeEventListener(eventName, eventListener);
      }, 1000);
    }
  });
}